import { motion } from "motion/react";
import { Menu, X, Globe } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const LOGO_URL = "/logo.png";

export default function Nav() {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'id' ? 'en' : 'id';
    i18n.changeLanguage(newLang);
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-20">
        <div className="flex items-center gap-2">
          <img src={LOGO_URL} alt="Logo" className="h-10 w-auto" referrerPolicy="no-referrer" />
          <span className="text-xl font-bold text-slate-900 tracking-tighter hidden sm:block">PT. Lentera Sastra Loka</span>
        </div>
        
        <div className="hidden md:flex items-center space-x-8">
          <a href="#solutions" className="text-primary-container border-b-2 border-primary-container pb-1 text-sm font-medium">{t('nav.solutions')}</a>
          <a href="#ai-development" className="text-slate-600 hover:text-primary-container transition-colors text-sm font-medium">{t('nav.ai_development')}</a>
          <a href="#infrastructure" className="text-slate-600 hover:text-primary-container transition-colors text-sm font-medium">{t('nav.infrastructure')}</a>
          <a href="#tech-stack" className="text-slate-600 hover:text-primary-container transition-colors text-sm font-medium text-nowrap">{t('nav.tech_stack')}</a>
          <a href="#insights" className="text-slate-600 hover:text-primary-container transition-colors text-sm font-medium">{t('nav.insights')}</a>
          <a href="#clients" className="text-slate-600 hover:text-primary-container transition-colors text-sm font-medium">{t('nav.clients')}</a>
        </div>

        <div className="flex items-center gap-4">
          <button 
            onClick={toggleLanguage}
            className="flex items-center gap-1 text-sm font-medium text-slate-600 hover:text-primary-container transition-colors"
          >
            <Globe className="w-4 h-4" />
            <span className="uppercase">{i18n.language}</span>
          </button>
          <a href="#contact" className="bg-primary-container text-white px-6 py-2.5 rounded font-bold text-sm hover:bg-orange-600 transition-all active:scale-95">
            {t('nav.contact')}
          </a>
          <button className="md:hidden" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X className="text-slate-900" /> : <Menu className="text-slate-900" />}
          </button>
        </div>
      </div>
      
      <motion.div 
        initial={false}
        animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
        className="md:hidden overflow-hidden bg-white px-6 py-4 space-y-4"
      >
        <a href="#solutions" onClick={() => setIsOpen(false)} className="block text-primary-container font-medium">{t('nav.solutions')}</a>
        <a href="#ai-development" onClick={() => setIsOpen(false)} className="block text-slate-600 font-medium">{t('nav.ai_development')}</a>
        <a href="#infrastructure" onClick={() => setIsOpen(false)} className="block text-slate-600 font-medium">{t('nav.infrastructure')}</a>
        <a href="#tech-stack" onClick={() => setIsOpen(false)} className="block text-slate-600 font-medium">{t('nav.tech_stack')}</a>
        <a href="#insights" onClick={() => setIsOpen(false)} className="block text-slate-600 font-medium">{t('nav.insights')}</a>
        <a href="#clients" onClick={() => setIsOpen(false)} className="block text-slate-600 font-medium">{t('nav.clients')}</a>
        <a href="#contact" onClick={() => setIsOpen(false)} className="block text-slate-600 font-medium">{t('nav.contact')}</a>
      </motion.div>
    </nav>
  );
}